export type NonArray<T> = T & { length?: never }

function getLast<T>(array: T[] | undefined) {
  return array?.[array.length - 1] ?? undefined
}

export default getLast
